import device from "./reducer";

export default device;
